import { v4 as uuidv4 } from 'uuid'

interface Props {
  [key: string]: any
}

export default function HomClassroomAltIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()
  return (
    <svg fill="none" viewBox="0 0 29 18" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.625 0.104248H8.66667C8.26417 0.104248 7.9375 0.430915 7.9375 0.833415V16.8751C7.9375 17.2776 8.26417 17.6042 8.66667 17.6042H27.625C28.0275 17.6042 28.3542 17.2776 28.3542 16.8751V0.833415C28.3542 0.430915 28.0275 0.104248 27.625 0.104248Z"
        fill={`url(#${uuid}paint0_linear_194:5816)`}
      />
      <path
        d="M13.4062 6.66663C13.2816 6.66663 7.9375 6.66663 7.9375 6.66663V10.3125C7.9375 10.3125 13.2816 10.3125 13.4062 10.3125C14.4132 10.3125 15.2292 9.49652 15.2292 8.48954C15.2292 7.48256 14.4132 6.66663 13.4062 6.66663Z"
        fill="black"
        opacity="0.05"
      />
      <path
        d="M13.4062 7.03125C13.2794 7.03125 7.9375 7.03125 7.9375 7.03125V9.94792C7.9375 9.94792 13.2794 9.94792 13.4062 9.94792C14.212 9.94792 14.8646 9.29531 14.8646 8.48958C14.8646 7.68385 14.212 7.03125 13.4062 7.03125Z"
        fill="black"
        opacity="0.07"
      />
      <path
        d="M3.5623 5.93758C1.95813 5.93758 0.64563 4.62508 0.64563 3.02091C0.64563 1.41675 1.95813 0.104248 3.5623 0.104248C5.16646 0.104248 6.47896 1.41675 6.47896 3.02091C6.47896 4.62508 5.16646 5.93758 3.5623 5.93758Z"
        fill={`url(#${uuid}paint1_linear_194:5816)`}
      />
      <path
        d="M13.406 7.39575H3.5623C1.95157 7.39575 0.64563 8.70169 0.64563 10.3124V16.8749C0.64563 17.2774 0.972297 17.6041 1.3748 17.6041H5.7498C6.1523 17.6041 6.47896 17.2774 6.47896 16.8749V10.3124C6.47896 9.90992 6.80563 9.58325 7.20813 9.58325H13.406C14.0098 9.58325 14.4998 9.09325 14.4998 8.4895C14.4998 7.88575 14.0098 7.39575 13.406 7.39575Z"
        fill={`url(#${uuid}paint2_linear_194:5816)`}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint0_linear_194:5816`}
          x1="7.9375"
          x2="28.3542"
          y1="8.85425"
          y2="8.85425"
        >
          <stop stopColor="#9AE6FF" />
          <stop offset="1" stopColor="#70B2FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint1_linear_194:5816`}
          x1="1.54907"
          x2="5.55948"
          y1="1.00769"
          y2="5.0181"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#7D38D6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint2_linear_194:5816`}
          x1="4.92584"
          x2="11.1223"
          y1="5.88054"
          y2="21.7202"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#7D38D6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
